/* eslint class-methods-use-this: "off" */
import { getOrThrow } from '@deephaven/utils';
import GridMouseHandler from "../GridMouseHandler.js";
import GridUtils from "../GridUtils.js";
/**
 * Detect when the tree expand/collapse button is clicked
 */
class GridRowTreeMouseHandler extends GridMouseHandler {
  static isInTreeBox(gridPoint, grid) {
    var column = gridPoint.column,
      row = gridPoint.row,
      x = gridPoint.x,
      y = gridPoint.y;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var gridX = metrics.gridX,
      gridY = metrics.gridY,
      firstColumn = metrics.firstColumn,
      allColumnXs = metrics.allColumnXs,
      allColumnWidths = metrics.allColumnWidths,
      allRowHeights = metrics.allRowHeights,
      allRowYs = metrics.allRowYs,
      visibleRowTreeBoxes = metrics.visibleRowTreeBoxes;
    if (column === firstColumn && row != null && visibleRowTreeBoxes.get(row) != null && x > gridX && y > gridY) {
      var columnX = getOrThrow(allColumnXs, column);
      var width = getOrThrow(allColumnWidths, column);
      var rowY = getOrThrow(allRowYs, row);
      var height = getOrThrow(allRowHeights, row);
      if (x >= gridX + columnX && x <= gridX + columnX + width && y >= gridY + rowY && y <= gridY + rowY + height) {
        return true;
      }
    }
    return false;
  }
  onDown(gridPoint, grid) {
    return GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid);
  }
  onClick(gridPoint, grid, event) {
    if (GridRowTreeMouseHandler.isInTreeBox(gridPoint, grid)) {
      var row = gridPoint.row;
      if (row !== null) {
        grid.toggleRowExpanded(row, GridUtils.isModifierKeyDown(event));
        return true;
      }
    }
    return false;
  }
}
export default GridRowTreeMouseHandler;
//# sourceMappingURL=GridRowTreeMouseHandler.js.map